// composables/useNovaPoshtaReal.js
import { ref } from "vue";

export function useNovaPoshtaReal() {
  const cities = ref([]);
  const warehouses = ref([]);

  async function searchCities(q = "") {
    if (!q?.trim()) {
      cities.value = [];
      return [];
    }
    cities.value = await $fetch("/api/np/cities", {
      method: "POST",
      body: { q, limit: 20 },
    }).catch(() => []);
    return cities.value;
  }

  async function searchWarehouses(cityRef, q = "", kind = "all") {
    if (!cityRef) {
      warehouses.value = [];
      return [];
    }
    warehouses.value = await $fetch("/api/np/warehouses", {
      method: "POST",
      body: { cityRef, q, kind, limit: 50 },
    }).catch(() => []);
    return warehouses.value;
  }

  return { cities, warehouses, searchCities, searchWarehouses };
}
